<template>
  <div
    v-if="seconds > 0"
    :class="[
      'absolute z-50 h-1 animate-leftGradient bg-soft-gradient bg-[length:200%_200%] transition-[width] duration-300 ease-linear',
    ]"
    :style="{ width: `${seconds}%` }"
  />
</template>

<script setup lang="ts">
import { ref, watch, onUnmounted } from "vue";

import { useLoadingStore } from "../store/loading";

const loading = useLoadingStore();
const seconds = ref(0);
let interval: ReturnType<typeof setInterval>;

watch(
  () => loading.isRouteLoading,
  (isLoading) => {
    if (isLoading) {
      seconds.value = 40;
      interval = setInterval(() => {
        if (seconds.value < 100) {
          seconds.value = Math.min(seconds.value + 40, 100);
        } else {
          seconds.value = 95;
          clearInterval(interval);
        }
      }, 100);
    } else {
      clearInterval(interval);
      seconds.value = 100;
      setTimeout(() => {
        seconds.value = 0;
      }, 200);
    }
  },
  { immediate: true }
);

onUnmounted(() => {
  clearInterval(interval);
});
</script>
